var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editingAllowed)?_c('span',[_c('switches',{attrs:{"theme":"custom","disabled":_vm.disabled,"color":_vm.color()},model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}}),_c('span',{staticClass:"switch-status",class:_vm.statusClass()},[_vm._v(" "+_vm._s(_vm.status())+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }